// @flow

const FACEBOOK = 'facebook';
const TWITTER = 'twitter';
const GOOGLE = 'google';
const YOUTUBE = 'youtube';
const GPLUS = 'gplus';
const MICROSOFT = 'microsoft';
const ETSY = 'etsy';
const INSTAGRAM = 'instagram';
const DROPBOX = 'dropbox';

type User = {
  connected_to_facebook?: boolean,
  connected_to_google?: boolean,
  connected_to_youtube?: boolean,
  connected_to_instagram?: boolean,
  connected_to_dropbox?: boolean,
  gplus_url?: string,
  connected_to_microsoft?: boolean,
  twitter_url?: string,
  connected_to_etsy?: boolean,
};

export type SocialNetworkState = {
  facebook: { connected: boolean },
  twitter: { connected: boolean, url: ?string },
  google: { connected: boolean },
  youtube: { connected: boolean },
  gplus: { connected: boolean, url: ?string },
  microsoft: { connected: boolean },
  etsy: { connected: boolean },
  dropbox: { connected: boolean },
};

export default function getSocialNetworkState(user: User): SocialNetworkState {
  return {
    [FACEBOOK]: {
      connected: user.connected_to_facebook || false,
    },
    [GOOGLE]: {
      connected: user.connected_to_google || false,
    },
    [YOUTUBE]: {
      connected: user.connected_to_youtube || false,
    },
    [GPLUS]: {
      connected: !!user.gplus_url,
      url: user.gplus_url,
    },
    [MICROSOFT]: {
      connected: user.connected_to_microsoft || false,
    },
    [TWITTER]: {
      connected: !!user.twitter_url,
      url: user.twitter_url,
    },
    [ETSY]: {
      connected: user.connected_to_etsy || false,
    },
    [INSTAGRAM]: {
      connected: user.connected_to_instagram || false,
    },
    [DROPBOX]: {
      connected: user.connected_to_dropbox || false,
    },
  };
}

export { FACEBOOK, TWITTER, GOOGLE, YOUTUBE, GPLUS, MICROSOFT, ETSY, DROPBOX };
